import { Injectable, OnInit, OnDestroy, Inject, InjectionToken } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpEvent} from '@angular/common/http';
import { Observable, concat, Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserAuthModel } from '../models/user-auth.model';
import { timeout } from 'rxjs/operators';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable()
export class WinAuthInterceptor implements HttpInterceptor, OnDestroy {

  private userAuth: UserAuthModel;
  userAuthSubscription: Subscription;

  constructor(private authService: AuthService,
    @Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number) {
    this.userAuthSubscription = this.authService.getAuthentication().subscribe(x => {
      this.userAuth = x;
    });
  }

  ngOnDestroy(): void {
    this.userAuthSubscription.unsubscribe();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    req = req.clone({
      headers: req.headers
        .set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache')
        .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
    });
  
    if (this.userAuth) {
      var token = this.userAuth.Token;
      req = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + token) });
    }

    // if this is a login-request the header is
    // already set to x/www/formurl/encoded.
    // so if we already have a content-type, do not
    // set it, but if we don't have one, set it to
    // default --> json
    if (!req.headers.has('Content-Type')) {
      req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
    }

    // adding this parameter during the request generations, it don't work, so must be added in this interceptor
    if (req.headers.has('Autologin')){
      req = req.clone({ withCredentials: true });
    }

    const timeoutValue = Number(req.headers.get('timeout')) || this.defaultTimeout;

    return next.handle(req).pipe(timeout(timeoutValue));
  }
}
